import { render, staticRenderFns } from "./CourseTitle.vue?vue&type=template&id=761ea79e&scoped=true"
import script from "./CourseTitle.vue?vue&type=script&lang=js"
export * from "./CourseTitle.vue?vue&type=script&lang=js"
import style0 from "./CourseTitle.vue?vue&type=style&index=0&id=761ea79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ea79e",
  null
  
)

export default component.exports